export default {"src":"/_next/static/media/Couch.9fb754cb.svg","height":63,"width":112};